<app-product-tour-background />

@if(currentStep) {
  <div
    class="caret"
    [class.bottom]="caretAlign.bottom"
    [ngStyle]="{ top: caretAlign.top, left: caretAlign.left, right: caretAlign.right, bottom: caretAlign.bottom }"
    [@fadeInOut]
    data-cy="product-tour-caret">
  </div>

  <div class="tooltip" [ngStyle]="{ top: tooltipAlign.top, left: tooltipAlign.left, right: tooltipAlign.right, bottom: tooltipAlign.bottom }" [@fadeInOut] data-cy="product-tour-tooltip">
    <div class="text">{{ currentStep.text | translate }}</div>
    <div class="bottom-container" [class.multiple]="currentStep.illustration">
      @if(currentStep.illustration) { <img src="assets/imgs/product-tour/{{ currentStep.illustration.url }}" alt="" [class.align-bottom]="currentStep.illustration.align === 'bottom'" /> }

      <div class="action-buttons-container">
        @if(currentStep.allowBack) {
          <app-button
            data-cy="product-tour-back-step"
            class="back-button"
            (click)="productTourService.previousStep()"
            [icon]="'assets/icon/left-arrow.svg'"
            [size]="'small'"
            [shape]="'circle'"/>
        }

        <app-button (click)="productTourService.nextStep()" [label]="currentStep.buttonLabel | translate" [size]="'small'" data-cy="product-tour-next-step"/>
      </div>
    </div>
    @if(currentStep && currentStep.skip) { <div  class="skip" (click)="productTourService.endTour()" data-cy="product-tour-skip">{{ 'PWA_featureWalkthru_CTA_link_skip' | translate }}</div> }
  </div>
}



